import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers } from "../data/landing";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const cycle = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(cycle, FIRST_DELAY);
    const loop = window.setInterval(cycle, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed left-3 right-3 top-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto sm:top-auto" aria-live="polite" data-id="element-56" data-mp="115ute5uefyqb">
      <AnimatePresence data-id="element-57" data-mp="1fxn0juk1i6gy">
        {show && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative mx-auto flex max-w-sm items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-[0_14px_40px_-10px_rgba(11,27,58,0.4)] sm:mx-0" data-id="element-58" data-mp="1ay0mxk0auo7m">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-cta/10 text-cta" data-id="element-59" data-mp="28imwl36dmvll">
              <BadgeCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-60" data-mp="23nhekfg3i12s" />
            </span>
            <div className="min-w-0" data-id="element-61" data-mp="2aobbwi679qtv">
              <p className="text-sm leading-snug text-ink" data-id="element-62" data-mp="2fnec9pb8j8vi">
                <strong className="text-navy" data-id="element-63" data-mp="2fpr0ulbi0hhj">{buyer.name}</strong> from {buyer.place}
              </p>
              <p className="text-sm leading-snug text-ink/75" data-id="element-64" data-mp="2kko5lg1qw4om">
                just purchased <strong className="text-navy" data-id="element-65" data-mp="2plbxs51pmrkf">Lipo Planning Workbook™</strong>
              </p>
              <p className="mt-0.5 text-xs text-navy/50" data-id="element-66" data-mp="1rzmxmf282jr2">{minutesAgo} min ago · Verified purchase</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-md p-1 text-navy/40 transition-colors duration-150 hover:text-navy" data-id="element-67" data-mp="1wxg5rdn35ntz">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-68" data-mp="1972ie0fg4d5q" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}